export const iconFontAwesomeArrowsUpLong = (
	<i className="fa-solid fa-up-long"></i>
);
